// Card message ("modtagerbesked") on Gavekurv line items.
// Saves the message without leaving the cart drawer. Uses the line index
// (not the line key) because changing a line item property changes its key.
(function () {
  var TEXTAREA = 'cart-item-property-value-textarea';
  var SUBMIT = 'cart-item-property-submit';

  function statusEl(textarea) {
    var wrap = textarea.closest('.cart-item-property');
    return wrap ? wrap.querySelector('.cart-item-property-status') : null;
  }

  function setStatus(textarea, text, saved) {
    var status = statusEl(textarea);
    if (!status) return;
    status.textContent = text;
    status.classList.add('show-msg');
    status.classList.toggle('is-saved', saved === true);
  }

  function save(textarea) {
    var body = {
      line: textarea.dataset.line,
      quantity: textarea.dataset.quantity,
      properties: { modtagerbesked: textarea.value }
    };
    setStatus(textarea, 'Gemmer…', false);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart change failed');
        return response.json();
      })
      .then(function () {
        setStatus(textarea, 'Gemt', true);
      })
      .catch(function () {
        setStatus(textarea, 'Kunne ikke gemme – prøv igen', false);
      });
  }

  // Delegated listeners so they work for both the static cart page and the
  // dynamically re-rendered cart drawer.
  document.addEventListener('input', function (e) {
    if (e.target.classList.contains(TEXTAREA)) {
      setStatus(e.target, 'Ikke gemt', false);
    }
  });

  document.addEventListener('focusout', function (e) {
    if (e.target.classList.contains(TEXTAREA)) {
      save(e.target);
    }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.classList.contains(SUBMIT)) return;
    var wrap = e.target.closest('.cart-item-property');
    var textarea = wrap ? wrap.querySelector('.' + TEXTAREA) : null;
    if (textarea) save(textarea);
  });
})();
